<!-- 我的页面 -->
<template>
  <div v-show="$store.state.welcomeLogin&& isShow" >
    <div class="backmodal" @touchmove.stop.prevent="moveHandle" >
      <div class="backflex" >
        <div class="b_content">
          <div class="box">
             <div class="sub_text" style="margin-bottom: 23px;padding-top:20px">
          欢迎登陆 thombrowne 中国官网
          <div
            class="sub_text_content"
          >为了给您提供更好的购物和服务体验，我们对Thom Browne中国官网进行了全面升级，本次升级需要您重新登录帐号并绑定手机号，未来可以通过手机号及验证码的方式登录Thom Browne中国官网。</div>
        </div>
        <div class="sub_btn" @click="goLoginPage(true)">
          立即绑定
          <Icon type="ios-arrow-forward" />
        </div>
        <div class="sub_btn_cancel" @click="goLoginPage()">
          继续浏览
          <Icon type="ios-arrow-back" style="color:#000000" />
        </div>
           
          </div>
          <div class="b_close" @click="close">
            <img src="@/assets/image/icon/close.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  data() {
    return {
      isShow:true
    };
  },
  props: {},
  created() {},
   watch: {
    "$route": function(newVal, oldVal) {
      if(newVal.name=='email-register' || newVal.name=='login'){
        this.isShow = false;
      }else{
        this.isShow = true;
      }
      
    }
  },
  mounted(){
    let route = this.$route.name;
  
    if(route=='email-register' || route=='login'){
      this.isShow = false;
    }
  },

  methods: {
    //遮罩层穿透，阻止底部滑动
    moveHandle() {
      return;
    },
    close() { 
      this.$emit("close");
      this.isShow = false;
      // this.welcomelogin = false;
    },
    goLoginPage(type) {
      //立即绑定
      window.localStorage.setItem("welcomeLogin", true);
      this.$store.commit("setValue", ["welcomeEmailFlag", true]);
      this.$emit("close");
      if (type) {
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.pc {
  display: block;
}
.mobile {
  display: none;
}
.backmodal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(104, 104, 104, 0.6);
  z-index: 999;
  .backflex {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .b_content {
      width: 400px;
      padding: 20px 24px 31px;
      background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      .box {
        width: 100%;
        text-align: center;
        .sub_text {
    text-align: left;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c5d5f;
    .sub_text_content {
      padding-top: 2.6rem;
    }
  }
  .sub_btn {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    background: #5c5d5f;
    border: 1px solid #5c5d5f;
    line-height: 34px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 33px;
    padding: 0px 20px;
  }
  .sub_btn_cancel {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    background: #ffffff;
    border: 1px solid #5c5d5f;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5c5d5f;
    line-height: 32px;
    padding: 0px 20px;
    .ivu-icon {
      transform: rotate(180deg);
    }
  }
      }
      .b_close {
        cursor: pointer;
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        top: 2rem;
        right: 2rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .backmodal .backflex .b_content {
    width: 34rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 30rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .backmodal .backflex .b_content {
    max-width: 30rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 30rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
}
/deep/.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0.1rem;
}
/deep/.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.5rem;
}
/deep/.swiper-pagination-bullet {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #5c5d5f;
  opacity: 0.3;
}
/deep/.swiper-pagination-bullet-active {
  background-color: #5c5d5f;
  opacity: 1;
  margin: 0 0.5rem;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/WelcomeLoginPop2.vue